export default "/images/vendor/flag-icons/flags/1x1/sc.svg?fea26a158b05a81a819de715ca15618e";